import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const SCROLLBAR_SIZE = 6;
const SCROLLBAR_BORDER_RADIUS = theme.borderRadius.md;
const SCROLLBAR_TRACK_BACKGROUND = theme.swatches.gray[50];
const SCROLLBAR_THUMB_COLOR = theme.swatches.gray[200];
const SCROLLBAR_THUMB_COLOR_HOVER = theme.swatches.gray[300];
export const scrollbar = (options) => {
    const { trackMargin, trackBackground = SCROLLBAR_TRACK_BACKGROUND, trackSize = SCROLLBAR_SIZE, thumbColor = SCROLLBAR_THUMB_COLOR, thumbColorHover = SCROLLBAR_THUMB_COLOR_HOVER, } = options || {};
    const trackSizeRem = pxToRem(trackSize);
    return css `
    &::-webkit-scrollbar {
      width: ${trackSizeRem};
      height: ${trackSizeRem};
    }

    &::-webkit-scrollbar-track {
      margin-top: ${trackMargin && theme.spacing[trackMargin]};
      margin-bottom: ${trackMargin && theme.spacing[trackMargin]};
      border-radius: ${SCROLLBAR_BORDER_RADIUS};
      background: ${trackBackground};
    }

    &::-webkit-scrollbar-thumb {
      width: ${trackSizeRem};
      height: ${trackSizeRem};
      background: ${thumbColor};
      border-radius: ${SCROLLBAR_BORDER_RADIUS};

      &:hover {
        background: ${thumbColorHover};
      }
    }
  `;
};
